import React from 'react'

const FLinks = () => {
  return (
    <div className='footer-column-container-links'>
      <div className='footer-container-1-links'>
        <p>Blog</p>
        <p>Twitter</p>
        <p>Instagram</p>
        <p>Facebook</p>
      </div>
      <div className='footer-container-1-links'>
        <p>Site designed by <a href="https://www.linkedin.com/in/hrushikeshpatra24/">Hrushikesh</a> / logo from
         <a href="https://ionic.io/ionicons">ionicons</a> </p>
      </div>
     
    </div>
  )
}

export default FLinks